import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

// Constants
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'

// Contexts
import { useTheme } from '@homebotapp/hb-react-component-catalog'

// selectors
import { selectDaysUntilRenewal } from '../../../../../store/selectors/homeInsurance'

// Components
import { Text } from '../../../..'
import { ImportantNowCard } from '../../ImportantNowCard'

// Assets
import DefaultThemeSvg from './DefaultThemeSvg'
import LightThemeSvg from './LightThemeSvg'

const HomeInsurance = () => {
  const renewDays = useSelector(selectDaysUntilRenewal)
  const { theme } = useTheme()

  const Svg = theme.isLightThemeType ? LightThemeSvg : DefaultThemeSvg

  return (
    <ImportantNowCard
      winType='HomeInsurance'
      svgImage={Svg}
      navTo={OVERLAY_HELPERS.homeInsurance.buildPath('more-details')}
      data-qa='home-insurance-win'
      tracking={{
        guid: 'B5k7oWx7jgj7K7sfHvLqRfX',
        ui_context: 'homeownerDashboardWinHomeInsurance',
        descriptor: 'User clicked on Home Insurance card in Whats Important Now section in Homeowner Dashboard'
      }}
    >
      <FormattedMessage
        id='ImportantNow.spotlight.homeInsurance'
        defaultMessage='Your home insurance might renew in about {bold}'
        values={{
          bold: (
            <Text element='span' weight='semibold' variant='primary'>
              {renewDays} <FormattedMessage id='ImportantNow.spotlight.homeInsurance.days' defaultMessage='days' />
            </Text>
          )
        }}
      />
    </ImportantNowCard>
  )
}

HomeInsurance.propTypes = {}

export default HomeInsurance
